import React from 'react'
import Pt from 'prop-types'
import { Button, ControlLabel, FormControl, InputGroup } from 'react-bootstrap'
import Ipt from 'react-immutable-proptypes'

import { FormGroup } from 'internal-components/src/components/Form'
import AddressAutocomplete from 'internal-components/src/containers/Form/AddressAutocomplete'

export default function SignupAddressEntry({
  address,
  children,
  continueButton = true,
  errors,
  placeholder = 'Enter the address for your new service',
  setAddress,
  setAddressLocId,
}) {
  const onBlur = (e, data) => {
    if (!data.focusedSuggestion) {
      // We already got the suggestion set from onSuggestionSelected,
      // and blur will fire without the new value, so only pay attention
      // if a suggestion is not selected.
      setAddress(e.target.value)
    }
  }

  const onKeyPress = e => {
    if (e.key !== 'Enter') {
      return
    }

    setAddress(e.target.value)
  }

  const onSuggestionSelected = (e, { suggestion, suggestionValue }) => {
    e.preventDefault()

    setAddress(suggestionValue)
    // eslint-disable-next-line no-underscore-dangle
    setAddressLocId(suggestion.locId)
  }

  let renderInput
  if (continueButton) {
    renderInput = props => (
      <InputGroup>
        <FormControl {...props} />
        <InputGroup.Button>
          <Button bsSize="large" type="submit">
            Continue &rarr;
          </Button>
        </InputGroup.Button>
      </InputGroup>
    )
  }

  return (
    <div id="addressEntry">
      <FormGroup
        bsSize="large"
        controlId="addressInput"
        errors={errors}
        errorKey="address"
      >
        <ControlLabel>Service Address</ControlLabel>

        <AddressAutocomplete
          onBlur={onBlur}
          onKeyPress={onKeyPress}
          onSuggestionSelected={onSuggestionSelected}
          placeholder={placeholder}
          renderInput={renderInput}
          type="text"
          value={address || ''}
        />
        {children}
      </FormGroup>
    </div>
  )
}

SignupAddressEntry.propTypes = {
  address: Pt.string,
  children: Pt.node,
  continueButton: Pt.bool,
  errors: Ipt.map.isRequired,
  placeholder: Pt.string,
  setAddress: Pt.func.isRequired,
  setAddressLocId: Pt.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Signup/AddressEntry.jsx